export default "__VITE_ASSET__DslygVfJ__"